import { Button, type ButtonProps } from '@mui/material';

export const MLSAutofillButton = ({
  loading,
  ...props
}: Omit<ButtonProps, 'variant'>) => (
  <Button
    {...props}
    loading={loading}
    sx={{
      mb: { xs: 2, sm: 0 },
      whiteSpace: 'nowrap',
      ...props?.sx,
    }}
    size="large"
    fullWidth
    variant="outlined"
  >
    {loading ? 'MLS Autofilling' : 'MLS Autofill'}
  </Button>
);
